export default __webpack_public_path__ + "static/media/06_DAIF_Security_02.429d6208.mp4";